<template>
  <article>
    <div class="maxpro-rate">
      <template v-if="isAskRate">
        <h3 class="maxpro-rate__title">Оцените мероприятие</h3>
        <p class="maxpro-rate__sub">
          Ваша оценка поможет нам понять, что нужно улучшить или доработать
        </p>
      </template>
      <template v-else>
        <h3 class="maxpro-rate__title">Спасибо за вашу оценку!</h3>
        <p class="maxpro-rate__sub">
          Мы ценим каждый ваш отзыв и обязательно учтём все замечания
        </p>
      </template>

      <div class="maxpro-rate__stars" role="radiogroup" aria-label="Оценка по звёздам">
        <button
          v-for="n in 10"
          :key="n"
          :aria-checked="n === rating"
          role="radio"
          :class="['maxpro-rate__btn', { 'maxpro-rate__btn--disabled': !isAskRate }]"
          @click="setRating(n)"
          @mouseenter="hoverRating = n"
          @mouseleave="hoverRating = 0"
        >
          <star-svg
            class="maxpro-rate__star"
            :class="{
              'maxpro-rate__star--hovered': n <= hoverRating,
              'maxpro-rate__star--active': n <= rating,
            }"
          />
        </button>
      </div>

      <form v-if="isAskRate" class="maxpro-rate__form" @submit.prevent="submitRate">
        <label class="maxpro-rate__label" for="rate-comment"> Комментарий <span class="maxpro-rate__req">*</span> </label>
        <textarea
          id="rate-comment"
          class="maxpro-rate__textarea"
          v-model.trim="comment"
          required
          placeholder="Текст комментария"
        ></textarea>

        <button class="maxpro-rate__submit" type="submit" :disabled="sending">
          {{ sending ? "Отправляем..." : "Отправить" }}
        </button>
      </form>
    </div>
  </article>
</template>

<script>
import Vue from "vue"
import { mapGetters } from "vuex"
import Star from "@/public/dist/img/ax-max-pro/star.svg?inline"
import { AUTH_STORAGE_KEY_EMAIL, RATE_STORAGE_KEY } from "@pages/axoft-maximum-pro/consts/amp"

export default {
  name: "Rate",
  components: {
    "star-svg": Star,
  },
  props: {
    email: String
  },
  data() {
    return {
      rating: 0,
      comment: "",
      sending: false,
      hoverRating: 0,
      rateState: "ask", // ask | thanks
    }
  },
  created() {
    this.checkRateFromStorage()
  },
  computed: {
    ...mapGetters("lk", ["profile"]),
    isAskRate() {
      return this.rateState === "ask"
    },
  },
  methods: {
    setRating(n) {
      this.rating = n
    },
    checkRateFromStorage() {
      const rating = localStorage.getItem(RATE_STORAGE_KEY)
      if (rating) {
        this.rating = Number(rating)
        this.rateState = "thanks"
      }
    },
    async submitRate() {
      this.sending = true

      try {
        const email = localStorage.getItem(AUTH_STORAGE_KEY_EMAIL)
        await Vue.http.post('/api/events/setRate', {
          email,
          rating: this.rating,
          comment: this.comment,
        })

        localStorage.setItem(RATE_STORAGE_KEY, this.rating)
        this.rateState = "thanks"
      } catch (e) {
        console.error(e)
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style lang="sass">
@import "~@src/sass/params"

$muted: #4D556D
$accent: #1AB8C4

.maxpro-rate
  $border: #F5F5FA
  $radius: 6px

  &__title
    font-size: 20px
    font-weight: 600

  &__sub
    font-size: 16px
    line-height: 1.5
    margin-top: 16px
    color: $muted

  &__stars
    display: flex
    gap: 5px
    margin-top: 36px

  &__btn
    &--disabled
      pointer-events: none

  &__star
    width: 32px
    height: 31px
    display: grid
    place-items: center
    cursor: pointer
    color: #FFFFFF
    transition: color .5s

    &--hovered
      & path
        stroke: $accent

    &--active
      color: $accent

      & path
        stroke: $accent

  &__form
    margin-top: 25px

  &__label
    font-size: 14px

  &__req
    margin-left: 6px
    font-size: 13px
    color: #D65663

  &__textarea
    width: 100%
    min-height: 158px
    border-radius: $radius
    border: 1px solid $border
    padding: 12px 24px
    resize: vertical
    font: inherit
    margin-block: 8px 10px

    &::placeholder
      color: #293045
      font-size: 14px

  &__submit[type="submit"]
    justify-self: start
    padding: 12px 32px
    border-radius: 4px
    border: 0
    background: $accent
    color: #fff
    cursor: pointer
    transition: filter .15s

    &:hover
      filter: brightness(.95)

  @media (max-width: $mobile-size)
    display: flex
    flex-direction: column
    align-items: center
</style>



// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/components/maxpro-rate.vue